import React, { useEffect, useState } from "react"
import { Button } from "react-bootstrap"

export function graphIsShowing(scrolledCount, numOfGraphSelected, opIndex) {
  /* Figure out if graph would be showing on a scrolled page based on graph index */
  const startIdx = scrolledCount < 0 ? scrolledCount * -1 : scrolledCount
  const endIdx = startIdx + numOfGraphSelected

  return opIndex >= startIdx && opIndex < endIdx
}

export const getScrollingVariables = (graphs, width, numOfGraphSelected) => {
  /* Get panel size of graphs - numbers <= numOfGraphSelected will flex to fill the space */
  const graphNum = graphs.length
  const effectiveGraphNum = graphNum < numOfGraphSelected ? graphNum : numOfGraphSelected
  const panelWidth = width / Math.max(1, effectiveGraphNum)

  return [graphNum, effectiveGraphNum, panelWidth]
}

export const useHorzScroll = (graphs) => {
  const graphNum = graphs.length

  // While graphNum length is <= this number the graphs will flex to fill the space.
  // Larger numbers of graphs will be available via scrolling
  const [numOfGraphSelected, setNumOfGraphSelected] = useState(3)
  // To indicate the number/directionality of graphs that have been scrolled
  const [scrolledCount, setScrolledCount] = useState(0)

  useEffect(() => {
    if (
      scrolledCount !== 0 &&
      (graphNum <= numOfGraphSelected || scrolledCount < numOfGraphSelected - graphNum)
    ) {
      setScrolledCount(0)
    }
  }, [graphNum])

  const effectiveGraphNum = graphNum < numOfGraphSelected ? graphNum : numOfGraphSelected

  const graphIndexesShowing = []
  graphs.forEach((g, idx) => {
    if (graphIsShowing(scrolledCount, numOfGraphSelected, idx)) {
      graphIndexesShowing.push(idx)
    }
  })

  return [
    scrolledCount,
    setScrolledCount,
    numOfGraphSelected,
    setNumOfGraphSelected,
    effectiveGraphNum,
    graphIndexesShowing,
  ]
}

export default function HorzScroll({
  graphNum,
  numOfGraphSelected,
  scrolledCount,
  onGraphNumChange,
  onScrollChange,
}) {
  const [graphsCount, setGraphsCount] = useState(1)
  useEffect(() => {
    setGraphsCount(graphNum)
  }, [graphNum])

  const ScrollButton = ({ label, value, disabled }) => (
    <Button
      className={"btn-sm"}
      style={{ padding: "2px 4px 2px 4px", flexGrow: "1" }}
      variant={"primary"}
      disabled={graphsCount <= numOfGraphSelected || disabled}
      onClick={() => onScrollChange(value)}
    >
      <span style={{ fontSize: "75%" }}>{label}</span>
    </Button>
  )
  return (
    <div>
      <input
        style={{ width: "75px" }}
        type="number"
        min="1"
        max={graphsCount}
        className={"text-center"}
        step="1"
        value={numOfGraphSelected > graphsCount ? graphsCount : numOfGraphSelected}
        placeholder={numOfGraphSelected > graphsCount ? graphsCount : numOfGraphSelected}
        onWheel={(e) => e.target.blur()}
        onChange={(e) => {
          let value = !e.target.value || e.target.value < 0 ? 1 : e.target.value
          if (value > graphsCount) value = graphsCount
          onGraphNumChange(+Number(value).toFixed(0))
        }}
      />
      <div style={{ display: "flex" }}>
        <ScrollButton label={`<<`} value={0} disabled={scrolledCount === 0} />
        <ScrollButton label={`<`} value={scrolledCount + 1} disabled={scrolledCount + 1 > 0} />
        <ScrollButton
          label={`>`}
          value={scrolledCount - 1}
          disabled={scrolledCount - 1 < numOfGraphSelected - graphsCount}
        />
        <ScrollButton
          label={`>>`}
          value={numOfGraphSelected - graphsCount}
          disabled={scrolledCount === numOfGraphSelected - graphsCount}
        />
      </div>
    </div>
  )
}
